import { RiWhatsappFill } from "react-icons/ri";
import LlamaIcon from "V2.0/HomePages/Assistants/ModelSettings/Icons/LlamaIcon";

export default function WhatsappMetaIcon() {
  return (
    <div className="flex items-center relative">
      <RiWhatsappFill className="size-5 text-green-500 m-2" />
      <div className="absolute bottom-0.5 right-0.5">
        <LlamaIcon
          width={10}
          height={10}
        />
      </div>
    </div>
  );
}
